import PixelIcon from "@/components/PixelIcon";

export default function MacWindow({ id, testId, title, icon, dark = false, children }) {
    return (
        <section
            id={id}
            data-testid={testId}
            className={`mac-window scroll-mt-16 ${dark ? "mac-window-dark" : ""}`}
        >
            <div className="mac-titlebar" aria-hidden="true">
                <span className="mac-closebox" />
                <span className="mac-titlebar-title flex items-center gap-2">
                    {icon && <PixelIcon name={icon} dark={dark} className="h-3.5 w-3.5" />}
                    {title}
                </span>
            </div>
            <div className="px-5 py-10 md:px-12 md:py-16">{children}</div>
        </section>
    );
}
